module.exports = __webpack_public_path__ + "img/5_thumb.b69dbe4c.jpg";